import { Tooltip } from '@material-ui/core';
import { trim } from 'lodash-es';
import React, { useState } from 'react';

import { borderRadius, Text } from '~/src/dash/publicaUI';
import { publicaColors } from '~/src/dash/utils/colors';

interface ITruncatedList {
  displayStr: string;
  truncatedDescription?: string;
  disableSplitOnComma?: boolean;
}

export const TruncatedList = ({
  displayStr = '',
  truncatedDescription = '',
  disableSplitOnComma = false,
}: ITruncatedList) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isHover, setIsHover] = useState(false);

  // if no truncated description is provided, use a substring of the desired display
  let truncatedDisplay = <Text extraSmall>{displayStr}</Text>;
  if (truncatedDescription.length > 0) {
    truncatedDisplay = (
      <Text extraSmall bold>
        {truncatedDescription}
      </Text>
    );
  } else if (displayStr.length > 15) {
    <Text extraSmall>{displayStr.substring(0, 15) + '...'}</Text>;
  }

  const displayList = disableSplitOnComma ? [displayStr] : displayStr.split(',').map(trim);

  return (
    <Tooltip arrow title={`Click to ${isExpanded ? 'collapse' : 'expand'}`} placement='bottom'>
      <div
        onClick={() => setIsExpanded(!isExpanded)}
        onMouseEnter={() => setIsHover(true)}
        onMouseLeave={() => setIsHover(false)}
        style={{
          backgroundColor: isHover ? publicaColors.lightGray : publicaColors.veryLightGray,
          padding: '4px 12px',
          borderRadius: borderRadius.base,
          border: 'none',
          width: 'fit-content',
          textAlign: 'left',
          cursor: 'pointer',
        }}
      >
        {isExpanded ? displayList.map((item) => <Text extraSmall>{item}</Text>) : truncatedDisplay}
      </div>
    </Tooltip>
  );
};
